import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DndDirective } from '../../../../directives/dnd-directive';

@Component({
  selector: 'app-file-upload-input',
  templateUrl: './file-upload-input.component.html',
  styleUrls: ['./file-upload-input.component.scss'],
  standalone: true,
  imports: [DndDirective],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class FileUploadInputComponent implements ControlValueAccessor {
  @Input() multiple: boolean = false;
  @Input() accept: string[] = ['image/png', 'image/jpeg'];
  @Input() inputName: string = 'file';
  @Input() controlId: string | null = null;

  @Output() selectedFilesChange = new EventEmitter<File[]>();

  @ViewChild('input') input: ElementRef<HTMLInputElement> | undefined;

  public generatedRandomId = `file-${Math.random().toString(36).slice(2)}`;

  public onChange = (value: File[]) => {};
  public onTouched = () => {};

  public files: File[] = [];
  public disabled: boolean = false;

  public writeValue(value: File[]): void {
    if (value !== undefined) {
      this.files = value;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public handleInputChange(event: Event): void {
    if (this.disabled) return;
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.files = Array.from(input.files);
      this.onChange(this.files);
      this.onTouched();
      this.selectedFilesChange.emit(this.files);
    }
  }

  public handleFileDrop(files: FileList): void {
    if (this.disabled) return;
    this.files = Array.from(files);
    this.onChange(this.files);
    this.onTouched();
    this.selectedFilesChange.emit(this.files);
  }
}
